export class ProductForm extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['submit']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
    this.listeners.add(this.form, 'change', this.onFormChange.bind(this))
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  onFormChange (e) {
    if (e.target.hasAttribute('data-auto-submit')) {
      this.form.requestSubmit()
    }
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
